import { Typography } from '@mui/material';

type SectionTitleProps = {
  title: string;
};
export default function SectionTitle({ title }: SectionTitleProps) {
  return <Typography sx={{ fontWeight: 600, pb: 1 }}>{title}</Typography>;
}
